import React from 'react';
import { ButtonWithIcon } from '@els/els-react--button-next';
import { Messages } from '../../translations/message.models';

export interface CreateQuizBottomBarProps {
  messages: Messages;
  isStartQuizEnabled: boolean;
  questionCountSlot?: React.ReactNode;
  containerRef?: React.Ref<HTMLDivElement>;
}

// Back and Start Quiz have no destination yet (Home Focus Spec), but the buttons require a handler
const noop = () => undefined;

const CreateQuizBottomBar = ({ messages, isStartQuizEnabled, questionCountSlot, containerRef }: CreateQuizBottomBarProps) => (
  <div className="c-ssa-create-quiz-bottom-bar" ref={containerRef} role="region" aria-label={messages.QUIZ_ACTIONS} data-testid="ssa-create-quiz-bottom-bar">
    <div className="c-ssa-create-quiz-bottom-bar__container">
      <ButtonWithIcon
        type="link"
        sprite="ChevronLeft"
        className="c-ssa-create-quiz-bottom-bar__button"
        onClick={noop}
        data-testid="ssa-create-quiz-back-button"
      >
        <span className="c-ssa-create-quiz-bottom-bar__label u-els-font-size-h4">{messages.BACK}</span>
      </ButtonWithIcon>
      <div className="c-ssa-create-quiz-bottom-bar__slot" data-testid="ssa-create-quiz-question-count-slot">
        {questionCountSlot}
      </div>
      <ButtonWithIcon
        type="primary"
        iconRight
        sprite="ChevronRight"
        className="c-ssa-create-quiz-bottom-bar__button"
        disabled={!isStartQuizEnabled}
        onClick={noop}
        data-testid="ssa-create-quiz-start-quiz-button"
      >
        <span className="c-ssa-create-quiz-bottom-bar__label u-els-font-size-h4">{messages.START_QUIZ}</span>
      </ButtonWithIcon>
    </div>
  </div>
);

export default CreateQuizBottomBar;
